<template>
     <div class="rightContent">
        <div class="rightTitle clear">
            <div class="colorLump"></div>
            <div class="title">已上线课程</div>
        </div>
        <div class="main">
            <div class="search-condition">
                <div class="orgTopNavBox">
                    <div class="search-condition">
                        <div class="cour-con clear">
                            <div class="borders clear">
                                <div class="line"></div>
                                <div class="item" style="width: 90px;" @click="bindTab()">
                                    <span :class=" query.status == ''? 'cons actived':'cons'">全部课程</span>
                                </div>
                                <div class="item" style="width: 90px;" @click="bindTab(10)">
                                    <span :class=" query.status == 10? 'cons actived':'cons'">报名中</span>
                                    <span class="red_circle" v-if="listData.bmCount > 0">{{ listData.bmCount }}</span> 
                                </div>
                                <div class="item" style="width: 90px;" @click="bindTab(20)">
                                    <span :class=" query.status == 20? 'cons actived':'cons'">培训中</span>
                                    <span class="red_circle" v-if="listData.pxCount > 0">{{ listData.pxCount }}</span>   
                                </div>
                                <div class="item" style="width: 90px;" @click="bindTab(30)">
                                    <span :class=" query.status == 30? 'cons actived':'cons'">已结束</span>
                                    <span class="red_circle" v-if="listData.jsjCount > 0">{{ listData.jsCount }}</span>  
                                </div>
                                <div class="item" style="width: 110px;" @click="bindTab(11)">
                                    <span :class=" query.status == 11? 'cons actived':'cons'">取消待审核</span>
                                    <span class="red_circle" v-if="listData.qxdshCount > 0">{{ listData.qxdshCount }}</span>   
                                </div>
                                <div class="item" style="width: 110px;" @click="bindTab(-12)">
                                    <span :class=" query.status == -12? 'cons actived':'cons'">已取消</span>
                                    <span class="red_circle" v-if="listData.qxjCount > 0">{{ listData.qxCount }}</span>  
                                </div>
                            </div>
                            <span class="searchBox flex" >
                                <el-input v-model="query.search" placeholder="请输入课程名称或课程编号" />
                                <span class="search-font"  @click="getList(1)">搜索</span>
                                <span class="zero"  @click="bindReset">↻重置</span>
                                <el-select v-model="typeDataDefault" placeholder="请选择类型" clearable>
                                    <el-option 
                                    v-for="dict in typeData.list" 
                                    :key="dict.id" 
                                    :label="dict.name"
                                    :value="dict.id" 
                                    @click = "courseTypeClick()"/>
                                </el-select>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="result">
                    <div class="courList" v-for="item in listData.list" :key="item.id">
                        <ul>
                            <li class="cour-div">
                                <div class="cour-top">
                                    <span class="cour-tap">课程编号：{{ item.id }}</span>
                                    <span class="cour-number">招生人数：{{ item.lowerLimit }}-{{ item.upperLimit }}</span>
                                    <span class="cour-number">参课人数：{{ item.applyCount }}</span>
                                    <span class="cour-type download">{{ item.type == 0? '在线课程':'线下课程' }}</span>
                                    <router-link class="cour-same" :to="{path:'khyq',query:{id:item.id,listType:1}}">考核要求</router-link>
                                    <router-link v-if = "item.type == 0" class="cour-same" :to="{path:'khyq',query:{id:item.id,listType:2}}">直播列表</router-link>
                                    <span class="cour-take">操作</span>
                                    <span class="cour-status">状态</span>
                                </div>
                                <div class="cour-content">
                                    <span class="cour-info">
                                        <router-link  class="info-title" :to="{ path: '/coursedetail', query: { id: item.id } }">{{ item.name }}</router-link>
                                        <div class="info-min">
                                            <div>
                                                <span >开课时间</span>：{{ item.startTime }}至{{ item.endTime }}
                                            </div>
                                            <div>
                                                <span>课程费用</span>： {{ item.money }}
                                            </div>
                                            <div>
                                                <span>学分</span>：{{ item.credit }}
                                            </div>
                                        </div>
                                    </span> <span class="cour-sta">
                                        <div class="tableBox">
                                            <div class="subing">{{ item.statusMsg }}</div>
                                        </div>
                                    </span> <span class="courtake">
                                        <div class="tableBox">
                                            <router-link :to="{path:'sxckmd',query:{id:item.id} }" class="edit rates">参课名单</router-link>
                                            <router-link :to="{path:'ddlb',query:{id:item.id} }" class="edit rates">订单列表</router-link> 
                                            <div v-if="item.status == 10 && item.isApply == 1" class="edit red" @click="bindStop(item.id)">停止报名</div>
                                            <div v-if="item.status == 10" class="edit cancels" @click="cancleCourse(item.id)">取消课程</div>  
                                        </div>
                                    </span>
                                    <div class="course_poster" @click="handlePoster(item)">海报下载</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="!listData.list.length" class="emptyBox">暂无数据</div>
                </div>
            </div>
            <el-pagination v-if="listData.list.length" background layout="prev, pager, next" :total="listData.total" :page-size="query.pageSize" @current-change="bindPage" />
        </div>
    </div>
</template>
<script setup>
import { onlinelist,stopApply,cancelCourse,getCourseTypeList ,getCoursePoster} from '../../server/jigou/course'
import { ref, reactive,getCurrentInstance } from 'vue'
import {downLoadPoster} from "../../server/base";
import { bind } from 'lodash';

const { proxy } = getCurrentInstance()
const query = reactive({
    status: '',// 1待提交 2待审核 3审核不通过 4审核通过
    search: '',
    pageSize: 10,
    pageNum: 1,
    type:'',
})
const queryParams = ref({})
const listData = reactive({
    list: {},
    total: 0,
    bmCount:'',
    pxCount:'',
    qxCount: '',
    qxdshCount: '',
    jsCount: '',
})
//课程类型
const typeData = reactive({
    list:[],
})
const typeDataDefault = ref('')
//获取课程评分列表
async function getList(page){
    if( page ){
        query.pageNum = page
    }
    query.type = typeDataDefault.value
    if (query.type == '') {
        delete query.type   
    }
    let res = await onlinelist(query)
    if( res != false ){
        listData.list = res.list
        listData.total = res.total
        listData.bmCount = res.bmCount
        listData.qxCount = res.qxCount
        listData.jsCount = res.jsCount
        listData.pxCount = res.pxCount
        listData.qxdshCount = res.qxdshCount
    }
}
//获取课程类型数据
async function getCourseTypeListData(){
    let res = await getCourseTypeList()
    if( res != false ){
        typeData.list = res
    }
}
function courseTypeClick(){
    getList(1)
}
getList()
getCourseTypeListData()
//tab切换
function bindTab(id){
    query.status = id || ''
    getList(1)
}
//重置
function bindReset(){
    query.search = ''
    query.type = ''
    query.status = ''
    query.pageNum = 1
    typeDataDefault.value = ''
    getList()
}
//分页
function bindPage(e){
    console.log(e);
    query.pageNum = e
    getList()
}
const stopQuery= reactive({
    courseId:'',
    apply: 2,
})
//停止报名
async function bindStop(id){
    console.log(id);
    stopQuery.courseId = id
    let res = await stopApply(stopQuery)
    if ( res != false ){
        proxy.$modal.msgSuccess("停止报名成功");
        getList()
    } 
}
const cancleQuery =reactive({
    courseId:'',
})
//取消课程
async function cancleCourse(id){
    cancleQuery.courseId = id
    let res = await cancelCourse(cancleQuery)
    if ( res != false ){
        proxy.$modal.msgSuccess("取消课程成功");
        getList()
    } 
}
//海报下载
async function handlePoster(item){
  let res = await getCoursePoster(item.id);
  if (res != false) {
      downLoadPoster(res.poster,queryParams.value,`课程海报${new Date().getTime()}`)
    // downLoadFile(res.poster,queryParams.value,`课程海报${new Date().getTime()}.jpeg`)
  }
}
</script>
<style scoped>
.searchBox{
    align-items: center;
}
.zero{
    display: inline-block;width: 100px;
}
.cour-content{
    position: relative;
}
.course_poster{
    position: absolute;
    width: 90px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    background: linear-gradient(94deg, #0086f1, #3e58c9);
    border-radius: 12px;
    top: 70px;
    left: 420px;
}
</style>